import moment from 'moment-timezone';
import { getPointMoment } from './pointTime';

import { ACTIVITY_GRACE_MS } from './deviceOnlineTiming';

export const CONNECTION_LOST_THRESHOLD_MINUTES = 30;
export const STREAMING_LOST_THRESHOLD_MINUTES = 2;
export const DEVICE_ACTIVITY_GRACE_MS = ACTIVITY_GRACE_MS;

export function minutesSincePointUpdate(pointTime) {
    if (!pointTime) {
        return Infinity;
    }

    const lastUpdateDate = getPointMoment(pointTime);
    return Math.max(0, moment.duration(moment().diff(lastUpdateDate)).asMinutes());
}

export function isDeviceConnected(pointTime) {
    return minutesSincePointUpdate(pointTime) <= CONNECTION_LOST_THRESHOLD_MINUTES;
}

export function isStreamingConnected(pointTime) {
    return minutesSincePointUpdate(pointTime) <= STREAMING_LOST_THRESHOLD_MINUTES;
}

export function getLastPointPacketIdentity(data) {
    const info = data?.points?.[0]?.point?.info;
    if (!info) {
        return null;
    }

    const pktNum = info.PKT_NUM ?? info.PKTN;
    if (pktNum == null) {
        return null;
    }

    return {
        pktNum,
        missionNum: info.MISSION_NUM ?? info.MSN ?? null,
    };
}

export function isSamePacketIdentity(previous, current) {
    if (!previous || !current) {
        return false;
    }

    if (previous.pktNum !== current.pktNum) {
        return false;
    }

    return previous.missionNum === current.missionNum;
}

export function resolveDeviceOnlineFromPoll({
    previousPacket,
    currentPacket,
    lastActivityAt,
    now = Date.now(),
}) {
    if (!currentPacket) {
        return {
            isOnline: false,
            lastPacket: previousPacket,
            lastActivityAt,
        };
    }

    if (!previousPacket) {
        return {
            isOnline: false,
            lastPacket: currentPacket,
            lastActivityAt: null,
        };
    }

    const isNewPacket = !isSamePacketIdentity(previousPacket, currentPacket);

    if (isNewPacket) {
        return {
            isOnline: true,
            lastPacket: currentPacket,
            lastActivityAt: now,
        };
    }

    if (lastActivityAt != null && now - lastActivityAt <= DEVICE_ACTIVITY_GRACE_MS) {
        return {
            isOnline: true,
            lastPacket: currentPacket,
            lastActivityAt,
        };
    }

    return {
        isOnline: false,
        lastPacket: currentPacket,
        lastActivityAt,
    };
}
